import React from "react";
import "./WarningText.css";

interface Props {
  text: string;
}

function WarningText(props: Props) {
  const {text } = props;

  return (
    <span className="warning-text-line">
      <span className="warning-word">Warning</span>: {text}
    </span>
  );
}

export default WarningText;
